/* eslint-disable */

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Vuetify imports
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css'   
 
//
import '@/assets/theme.css'



// Create Vuetify instance
/*
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        colors: {
          background: '#212121'
        }
      }
    }
  },
  icons: {
    defaultSet: 'mdi', // ✅ tell Vuetify to use MDI
  },
});*/
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#ffffff',
          surface: '#ffffff',
          primary: '#1e88e5',
          footer: '#ededed',
          card: '#ededed',
          accent: '#1F7A63'
        },
      },
      dark: {
        dark: true,
        colors: {
          background: '#212121',
          surface: '#1e1e1e',
          primary: '#90caf9',
          footer: '#313131',
          card: '#313131',
            accent: '#1F7A63'
        },
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
  },
});






// Create Vue app and mount with Vuetify
createApp(App)
  .use(store)
  .use(router)
  .use(vuetify)
  .mount("#app");
